import Typewriter from '../src/index.js';

document.addEventListener('alpine:init', () => {
    Typewriter(window.Alpine);
});
